<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    title="Merge Tags"
    submit-name="Merge"
    @submit="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <p class="text-gray-700 mb-4">
      Are you sure you want to merge these tags?
    </p>
    <ul class="mt-2 pl-2 text-gray-700">
      <li v-for="tag in toMerge" :key="tag.slug" class="m-3 list-disc">
        <span class="mr-2">{{ tag.label }}</span>
        <span class="text-xs text-gray-500"
          >(Present in {{ tag.nTopics }} Topics and
          {{ tag.nSources }} Sources)</span
        >
      </li>
    </ul>
    <div>
      <lm-input
        ref="mergeTag"
        class="py-6 pr-8"
        label="merge tags into tag"
        @submit="submitFromInput"
      />
    </div>
    <div class="flex items-center mt-5 px-2 py-4 border">
      <lm-icon icon="warning" class="text-error mr-3" />
      <p class="m-0 text-gray-700">
        Please note: this action cannot be undone.
      </p>
    </div>
  </form-modal>
</template>

<script>
import {mapGetters} from 'vuex'
import LmIcon from '@/components/ui/LmIcon'
import LmInput from '@/components/form/LmInput'
import EventHub from '@/lib/eventHub'
import {AlertMessages, Events, Modal} from '@/lib/definitions'
import FormModal from '@/components/modals/FormModal'
import FormHelper from '@/components/form/formHelper'

export default {
  name: Modal.MERGE_TAGS,
  components: {
    LmIcon,
    FormModal,
    LmInput
  },
  data() {
    return {
      Events,
      modalName: Modal.MERGE_TAGS,
      modalRef: null,
      inputs: null,
      toMerge: []
    }
  },
  computed: {
    ...mapGetters(['currentLandscape']),
    ...mapGetters({selectedTags: 'tags/selected'})
  },
  mounted() {
    this.toMerge = this.selectedTags.map(slug =>
      this.currentLandscape.tags.find(t => t.slug === slug)
    )
    this.$refs.mergeTag.data = this.toMerge[0].label // TODO: pref from store
    this.inputs = [this.$refs.mergeTag]
    this.modalRef = this.$refs[this.modalName]
  },
  methods: {
    submitFromInput() {
      this.modalRef.submit()
    },
    submit() {
      if (FormHelper.validate(this.inputs)) {
        this.$store
          .dispatch('mergeTags', {
            merge: this.toMerge.map(t => t.slug),
            label: this.$refs.mergeTag.data
          })
          .then(() => this.modalRef.submitSuccess())
          .catch(error => this.modalRef.submitFails(error))
      } else {
        this.modalRef.submitFails()
      }
    },
    modalClosed({fromSubmit}) {
      if (fromSubmit) {
        EventHub.emit(Events.SHOW_SNACKBAR, AlertMessages.TAGS_MERGE)
      }
    }
  }
}
</script>
